export const LocationSelectAttempt = 'LocationSelectAttempt'
export const LocationSelectBegin = 'LocationSelectBegin'
export const LocationSelectCancel = 'LocationSelectCancel'
export const LocationSelectClick = 'LocationSelectClick'
export const LocationSelectFail = 'LocationSelectFail'
export const LocationSelectSuccess = 'LocationSelectSuccess'
